//@flow
import Collection from '../../Utils/Collection/parsedCollection';
import QuoteItemModel from './quoteItemModel';
import _ from 'underscore';

import type ProductsCollection from '../../Stores/Products/productsCollection';
import type { QuoteItemObject } from './quoteItemModel';

export default class QuoteItemsCollection extends Collection<QuoteItemObject, QuoteItemModel> {
  __modelClass() {
    return QuoteItemModel;
  }

  getIds():string[] {
    return this.models.map(model => model.getId());
  }

  getSkus():string[] {
    return this.models.map(model => model.getSku());
  }

  getQuoteItemBySku(sku:string):?QuoteItemModel {
    return this._getModelByAttribute('sku', sku);
  }

  getQuoteItemsBySkus(skus:string[]):QuoteItemModel[] {
    return this._getModelsByAttributes('sku', skus);
  }

  getQuoteItemSkus():string[] {
    return this.models.map((item) => item.getSku());
  }

  getTotalItemsQty():number {
    let totalQty = 0;
    this.models.forEach(model => totalQty += model.getQty());
    return totalQty;
  }

  getReservedItems() {
    return _getCollectionForModels(this.models.filter(model => model.isReserved()));
  }

  getNonReservedItems() {
    return _getCollectionForModels(this.models.filter(model => !model.isReserved()));
  }

  areAllReserved() {
    return this.models.every(model => model.isReserved());
  }

  getNotAllowedInCountryItems(country:string, products:ProductsCollection) {
    const filtered = this.models.filter(model => {
      const product = products.getProductBySku(model.getSku());
      return product && !product.isAllowedInCountry(country);
    });

    return _getCollectionForModels(filtered);
  }
}

function _getCollectionForModels(models:QuoteItemModel[]):QuoteItemsCollection {
  const skus:string[] = models.map(model => model.getSku());
  return new QuoteItemsCollection(_.object(skus, models.map(model => model.attributes)));
}
